import { SDK } from "@ing-tours/vue-search-sdk";

const search = new SDK({
  baseURL: "/search",
});

export default search;
